<template>
    <div>
  <v-card>
    <v-card-title>
        Manage UPI
      <v-spacer></v-spacer>
        <v-btn color="primary" @click="addupi=true">ADD UPI</v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="upis"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.Autono }}</td>
        <td >{{ props.item.UpiId }}</td>
        <td >{{ props.item.User_Name }}</td>
        <td > <v-btn @click="removeUPI(props.item)" small color="error">Delete</v-btn></td>
      </template>      
    </v-data-table>
  
  </v-card>
  <v-dialog
                v-model="proccess"
                persistent
                width="300">
                        <v-card
                        color="primary"
                        dark>
                                <v-card-text>Please wait
                                        <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                        />
                                        
                        </v-card-text>
                </v-card>
        </v-dialog>
        
  <v-dialog  v-model="addupi"
                width="350" height="300">
                        <v-card >
                    <v-card-title>Enter Detail</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                    <v-text-field
                                    type="text"
                                    style="width:300px;margin:0 auto;height:60px;"
                                    label="Enter UPI"
                                    v-model="upi"
                                    solo
                                    />          
                                    <v-btn color="primary" @click="verify" style="width:300px;margin-left:10px">Validate</v-btn>
                            </v-card-text>

                    </v-card>
        </v-dialog>
    </div>  
</template>
<script>
export default {
    data(){
        return{
            proccess:false,
            headers: [
                { text: 'S No', value: 'sno',align: 'left',sortable: false, },
                { text: 'UPI ID', value: 'upi' },
                { text: 'Username', value: 'username' },
                { text: 'Action', value:'btn'  },
            ],
            upis:[],
            upi:'',
            addupi:false
        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    mounted(){
        let vm = this;
        vm.getUPIID()
    },
    methods:{
        notification(type,message){
            this.$notify({
                    group: 'foo',
                    title: 'Important message',
                    text: message,
                    duration:5000, 
                    type:type               
            })
        },
        removeUPI(item){
            console.log(item); 
            let vm = this;
            let doc = {
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Source':'json',
                'Bank_Upi_Id':item.UpiId,
                'DataId':item.User_Name
                }           
            vm.proccess = true;
            vm.$store.dispatch("axiospost",{
                    url:"GetList_Of_YesBankUPI_ID",
                    data:doc,
            }).then(function (res) {
                    vm.proccess = false;
                    vm.getUPIID();
                    if(res.data.Status=="False"){
                        return vm.notification("error",res.data.Message);
                    }   
                    if(res.data.Status=="True") {                                        
                            vm.proccess = false;                            
                            return vm.notification("success","UPI Removed Successfully")
                    }
                    return vm.notification("success",res.data.Message);
            }).catch(function (error) {
                        vm.notification("error",error);
                        vm.proccess = false;
                        
            })   
        },
        getUPIID(){
            let vm = this;
            let doc = {
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Source':'json'
                }
            vm.$store.dispatch("axiospost",{
                    url:"GetList_Of_YesBankUPI_ID",
                    data:doc,
            }).then(function (res) {
                if(res.data!=null){
                    vm.upis = res.data
                }else{
                    vm.upis=[]
                }
            })

        },
        verify(){
            let vm = this;
            if(vm.upi=="") return vm.notification("error","UPI Required")
            let doc = {
                    'MobileNo':vm.user.phone,
                    'Password':vm.user.password,
                    'AuthKey':vm.user.authkey,
                    'Source':'json',
                    'Bank_Upi_Id':vm.upi
                    }
                vm.proccess= true;
                vm.$store.dispatch("axiospost",{
                        url:"YesBank_Validate_UPI_Id",
                        data:doc,
                }).then(function (res) {
                        console.log(res);            
                        vm.proccess = false;
                        if(res.data.Status=="False"){
                            return vm.notification("error",res.data.Message);
                        }   
                        if(res.data.Status=="True") {                                        
                                vm.proccess = false;
                                vm.upi = ""
                                vm.getUPIID();
                                return vm.notification("success","UPI Added Successfully")
                        }
                        return vm.notification("success",res.data.Message);
                }).catch(function (error) {
                        vm.notification("error",error);
                        vm.proccess = false;
                        
                })
        }

    }
}
</script>
